import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";

// Add your Firebase credentials
const config = {
  apiKey: "AIzaSyCO0hKiEfaRM38lZy34yxKdtykqeiTEuCE",
  authDomain: "ydcscratchathon.firebaseapp.com",
  databaseURL: "https://ydcscratchathon.firebaseio.com",
  projectId: "ydcscratchathon",
  storageBucket: "ydcscratchathon.appspot.com",
  messagingSenderId: "809568940400",
  appId: "1:809568940400:web:2cc03723ba707d77811fb5",
  measurementId: "G-SVRRWS9974",
};

if (firebase.apps.length < 1) {
  firebase.initializeApp(config);
}

if (window.location.hostname === "localhost") {
  firebase.functions().useEmulator("localhost", "5000");
}

export const auth = firebase.auth();
export const firestore = firebase.firestore();
export const functions = firebase.functions();

export default firebase;
